import React from 'react';
import { Link } from 'react-router-dom';
import { Typography } from 'amphitheatre';
import { FaChevronLeft } from 'react-icons/fa';
import { SaberLogo } from './About.styled';

import { LandingContainer, ReturnButton } from '../Landing.styled';

import Saber from './_img_saber_logo.png';

const { Header, Paragraph } = Typography;

const TitleStyle: React.CSSProperties = {
  marginTop: '1em',
};

function About(): React.ReactElement {
  return (
    <LandingContainer className="landing-container">
      <Link to="/">
        <ReturnButton>
          <div className="icon">
            <FaChevronLeft />
          </div>
          Return Home
        </ReturnButton>
      </Link>
      <Header style={TitleStyle}>ABOUT</Header>
      <Paragraph>
        Quest For Blue is the first in a series of Saber Astronautics “Quest”
        competitions to merge your entrepreneurial spirit with your passion for
        space. We want to give you a chance to apply your skills as space
        engineers, uncover new and interesting problems, and learn to compare
        their value in a business sense. For many of you this will be a fun
        ‘first principle’ look to go from a dozen ideas on the back of a napkin,
        to a single concept that is worth developing for investment.
      </Paragraph>
      <Paragraph>
        The ‘Quest’ in Quest For Blue is to design a space mission, the Blue is
        in reference to our planet; Earth AKA The Blue Marble. We’re asking you
        to design a space mission within the limits of Earth in a way that’s
        profitable, sustainable, and within the limits of the hypothetical seed
        money (US$10M) for your startup. Total Addressable Market (TAM) is the
        main tool to value your business concept.
      </Paragraph>
      <Paragraph>
        Our end goal for the Quest For Blue is to kickstart a community of space
        entrepreneurs. As the space industry grows around the world, we aim to
        make the Quest series a playground of exploration for smart people like
        yourselves to propose the business concepts of tomorrow. Who knows what
        new and interesting ideas you can come up with?
      </Paragraph>
      <hr />
      <Paragraph>
        Quest For Blue is a Saber Astronautics initiative as part of our mission
        to lower the barriers to space flight and democratize the industry.
        Saber has a long history of public engagement and support, training
        space engineers from undergraduate through to graduate level. We
        continue this tradition by exposing undergraduates to
        entrepreneurialism.
      </Paragraph>
      <hr />
      <Paragraph style={{ marginTop: '1em', textAlign: 'center' }}>
        Sydney, Australia | Adelaide, Australia | Colorado, USA
      </Paragraph>
      <Paragraph style={{ textAlign: 'center' }}>
        <SaberLogo src={Saber} />
      </Paragraph>
    </LandingContainer>
  );
}

export default About;
